<template>
    <div>
        <div class="eco-ui-loader-wrapper" v-show="loading">
            <div class="eco-ui-loader"></div>
        </div>
        <div class="eco-ui-loader-mask" v-show="loading"></div>
    </div>
</template>

<script>
import { EventBus } from '@/lib'

export default {
    name: 'LoadingComponent',
    data() {
        return {
            loading: false
        }
    },
    mounted() {
        var self = this;

        EventBus.$on('showLoadingComponent', () => {
            self.loading = true
            self.setScrollEnabled()
        })
        EventBus.$on('hideLoadingComponent', () => {
            self.loading = false
            self.setScrollEnabled()
        })
    },
    methods: {
        setScrollEnabled() {
            if (this.loading) {
                document.body.classList.add('body-loading')
            } else {
                document.body.classList.remove('body-loading')
            }
        }
    }
}
</script>
<style>
.body-loading {
    overflow: hidden;
}
.eco-ui-loader-wrapper {
    z-index: 1000;
    width: 100vw;
    height: 100vh;
    top: 100px;
    text-align: center;
}

.eco-ui-loader {
    border-radius: 50%;
    border: 7px solid #EAF0F6;
    border-top: 7px solid #000;
    width: 60px;
    height: 60px;
    animation: eco-ui-spinner 1.2s linear infinite;
    position: fixed;
    left: calc(50% - 60px);
    top: calc(50% - 60px);
    transform: translate(-50%,-50%);
}

@keyframes eco-ui-spinner {
  0% {
      transform: rotate(0deg);
  }

  100% {
      transform: rotate(360deg);
  }
}
@keyframes fadeInOpacity {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 0.3;
	}
}
.eco-ui-loader-mask {
    width: 100vw;
    height: 100vh;
    background-color: #000;
    opacity: 0.3;
    z-index: 1000000;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    overflow: hidden;
	animation-name: fadeInOpacity;
	animation-timing-function: ease-in;
	animation-duration: 0.8s;
}
</style>